import { ArrowUpRight } from "lucide-react";

/* Gratis-proefles promotiebanner (spec 10/11). Beheerbaar via Admin → Klanten → Proeflessen.
   promo_active=false verwijdert alleen deze melding; inschrijven blijft werken. */
export default function TrialPromo({ trialSettings, onCta }) {
  if (!trialSettings?.promo_active) return null;
  const title = trialSettings.promo_title || "Gratis proefles";
  const dateTxt = trialSettings.promo_date || "";
  return (
    <div className="border-2 p-5 md:p-6 mt-8 max-w-lg" style={{ borderColor: "var(--joh-accent)" }} data-testid="trial-promo">
      <div className="chip" style={{ color: "var(--joh-accent)" }} data-testid="trial-promo-title">
        {title}{dateTxt ? ` — ${dateTxt}` : ""}
      </div>
      {trialSettings.promo_description && (
        <p className="text-[#DDD6CB] mt-3 text-sm md:text-base" data-testid="trial-promo-description">{trialSettings.promo_description}</p>
      )}
      <button onClick={onCta} className="btn mt-5" style={{ background: "var(--joh-accent)", borderColor: "var(--joh-accent)", color: "#0A0A0A" }} data-testid="trial-promo-cta">
        {trialSettings.promo_cta || "Meld je aan voor de proefles"} <ArrowUpRight size={14}/>
      </button>
    </div>
  );
}
